export class ActiveUserSession {
    address: string;
    addressLine1: string;
    pincode: number;
    city: string;
    region: string;
    latitude: number;
    longitude: number;
    productId: number;
    locationReference: string;
    coverageStatus: string;
    email: string;
    addressLine2: any;
    suburb: any;
    buldingId: any;
    amId: any;
    complexName: any;
    complexNumber: any;
    buildingId: any;
    floor: any;
    predefinedPremiseId: any;


    isOWCP: boolean;
    isOWSP: boolean;
}
